import { Link } from "react-router-dom";
import { Facebook, Instagram } from "lucide-react";
import { BUSINESS, LOGO, NAV, SERVICES } from "../data/site";

export default function Footer() {
  return (
    <footer className="bg-[#0D0D0D] border-t border-white/10 pt-16 pb-8" data-testid="footer">
      <div className="container-lux grid md:grid-cols-4 gap-10">
        <div className="md:col-span-1">
          <img src={LOGO} alt="Sterling Roofworks" className="h-16 mb-4" />
          <p className="text-sm text-[#C8C8C8] leading-relaxed">{BUSINESS.tagline}</p>
        </div>

        <div>
          <p className="font-head uppercase tracking-wider text-sm text-[#D4AF37] mb-4">Explore</p>
          <ul className="space-y-2">
            {NAV.map((n) => (
              <li key={n.href}><a href={n.href} className="text-sm text-[#C8C8C8] hover:text-[#F8F8F8] transition-colors">{n.label}</a></li>
            ))}
          </ul>
        </div>

        <div>
          <p className="font-head uppercase tracking-wider text-sm text-[#D4AF37] mb-4">Services</p>
          <ul className="space-y-2">
            {SERVICES.slice(0, 6).map((s) => (
              <li key={s.slug}><Link to={`/services/${s.slug}`} className="text-sm text-[#C8C8C8] hover:text-[#F8F8F8] transition-colors">{s.title}</Link></li>
            ))}
          </ul>
        </div>

        <div>
          <p className="font-head uppercase tracking-wider text-sm text-[#D4AF37] mb-4">Sterling Roofworks</p>
          <a href={BUSINESS.phoneHref} data-testid="footer-call" className="block text-sm text-[#C8C8C8] hover:text-[#F8F8F8] transition-colors">{BUSINESS.phone}</a>
          <a href={`mailto:${BUSINESS.email}`} data-testid="footer-email" className="block text-sm text-[#C8C8C8] hover:text-[#F8F8F8] transition-colors">{BUSINESS.email}</a>
          <p className="text-sm text-[#C8C8C8] mt-3">Trading as {BUSINESS.legal}</p>
          <p className="text-sm text-[#C8C8C8]">Company No. {BUSINESS.companyNo}</p>
          <p className="text-sm text-[#C8C8C8] mt-3">{BUSINESS.address.map((l) => <span key={l} className="block">{l}</span>)}</p>
          <div className="flex gap-3 mt-4">
            <a href="#" aria-label="Facebook" className="w-9 h-9 rounded-full border border-white/15 flex items-center justify-center hover:border-[#D4AF37] hover:text-[#D4AF37] transition-colors"><Facebook size={16} /></a>
            <a href="#" aria-label="Instagram" className="w-9 h-9 rounded-full border border-white/15 flex items-center justify-center hover:border-[#D4AF37] hover:text-[#D4AF37] transition-colors"><Instagram size={16} /></a>
          </div>
        </div>
      </div>

      <div className="container-lux mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-3">
        <p className="text-xs text-[#C8C8C8]">© {new Date().getFullYear()} {BUSINESS.legal}. All rights reserved.</p>
        <div className="flex gap-5 text-xs text-[#C8C8C8]">
          <a href="#" className="hover:text-[#F8F8F8]">Privacy Policy</a>
          <a href="#" className="hover:text-[#F8F8F8]">Terms &amp; Conditions</a>
          <a href="#" className="hover:text-[#F8F8F8]">Cookie Policy</a>
        </div>
      </div>
    </footer>
  );
}
